<template>
  <section class="register">
    <div class="box">
      <div class="header">
        <div key="info" class="title">Informações</div>
        <div @click="$router.push('/producer')" class="close"><i class="fas fa-times"></i></div>
      </div>
      <form @submit.prevent class="form">
        <!-- Nome -->
        <label>Nome</label>
        <input v-model="name" type="text" placeholder="Nome do usuário" :class="{ error : error.includes('name') }" />
        <div v-if="error.indexOf('name') > -1" class="hint">você esqueceu de digitar o nome</div>
        <!-- E-mail -->
        <label>E-mail</label>
        <input v-model="email" type="text" placeholder="E-mail para login" :class="{ error : error.includes('email') || error.includes('producer-exists') }" />
        <div v-if="error.includes('email')" class="hint">você esqueceu de digitar o e-mail</div>
        <div v-if="error.includes('producer-exists')" class="hint">Já existe um produtor com este e-mail</div>
      </form>
      <div class="actions">
        <button @click="$router.push('/producer')" class="button-previous"><i class="fas fa-angle-left"></i><span>Cancelar</span></button>
        <button @click="save" class="button-save"><i class="fas" :class="loading ? 'fa-spinner loading' : 'fa-check'"></i><span>Confirmar</span></button>
      </div>
    </div>
  </section>
</template>

<script>
import logger from '../../logger'
import { create, update } from '../api/producer'

export default {
  name: 'producer',
  props: ['id', 'producerData'],
  data () {
    return {
      loading: false,
      error: [],
      name: null,
      email: null
    }
  },
  async mounted () {
    if (this.id !== 'new') {
      this.name = this.producerData.name
      this.email = this.producerData.login
    }
  },
  methods: {
    async save () {
      try {
        if (this.loading) return false
        this.loading = true
        this.error = []
        if (this.id === 'new') {
          await create(this.name, this.email)
        } else {
          await update(this.id, this.name, this.email)
        }
        this.loading = false
        this.$router.push('/producer')
      } catch (error) {
        const data = error.response ? error.response.data : {}
        // Validation error
        if (data.error === 'Validation error') {
          this.error = data.fields
        } else {
          logger.error(error, this)
        }
        this.loading = false
      }
    }
  }
}
</script>
